import { Parser } from 'html-to-react'
import * as _ from 'lodash-es'
import PropTypes from 'prop-types'
import React from 'react'

import { configureRepairOrderAction } from '../utils/renderHelpers'

const ExpandableRow = ({ data }) => (
  <div className="bg-white-dark flex flex-col px-3 py-2">
    <div className="flex flex-row">
      <div className="w-[195px] shrink-0 pl-[50px]">
        <span className="text-charcoal-400 text-xs font-bold">LINE ID</span>
      </div>
      <div className="w-[100px] shrink-0 px-2">
        <span className="text-charcoal-400 text-xs font-bold">TECH #</span>
      </div>
      <div className="w-[80vw] max-w-[400px] shrink-0 px-2">
        <span className="text-charcoal-400 text-xs font-bold">ACTION NEEDED</span>
      </div>
      <div className="w-full px-2">
        <span className="text-charcoal-400 text-xs font-bold">PROBLEM</span>
      </div>
    </div>

    {(!data.lineItems || data.lineItems.length === 0) && (
      <div className="text-charcoal-400 py-3 pl-[50px] text-sm italic">
        No line items added yet.
      </div>
    )}

    {_.map(data.lineItems, (lineItem) => (
      <div key={lineItem.id} className="flex flex-row py-1">
        <div className="w-[195px] shrink-0 pl-[50px] pr-4">
          <span className="text-charcoal text-sm font-semibold uppercase">
            {lineItem.lineName}
          </span>
        </div>
        <div className="w-[100px] shrink-0 px-2">
          <span className="text-charcoal-900 text-sm">{lineItem.technician}</span>
        </div>
        <div className="w-[80vw] max-w-[400px] shrink-0 px-2">
          <ul className="text-charcoal-900 flex flex-col gap-y-1 text-sm">
            {_.map(lineItem.actionsNeeded, (a) =>
              configureRepairOrderAction({ name: a.action.name, completed: a.completedAt }),
            )}
          </ul>
        </div>
        <div className="w-full max-w-[500px] px-2">
          <div className="text-charcoal-900 flex flex-col gap-y-1 text-sm">
            {_.map(lineItem.actionsNeeded, (a) =>
              a.problem ? <div key={a.id}>{Parser().parse(a.problem)}</div> : null,
            )}
            {_.every(lineItem.actionsNeeded, (a) => !a.problem) &&
              lineItem.problem &&
              Parser().parse(lineItem.problem)}
          </div>
        </div>
      </div>
    ))}
  </div>
)

ExpandableRow.propTypes = {
  data: PropTypes.object,
}

export default ExpandableRow
